// // import React, { useState } from "react";
// // import "./Header.css";
// // import img_log from "../Images/salesjetlog.png";
// // import ProfileMenu from "./Profilemenu";
// // import { FiGlobe } from "react-icons/fi";
// // import Newleadadding from "./Newleadadding";

// // const TimelineComponent = ({ userDetails, accessToken, onSearchChange, onGlobalSearch, connectionStatus,onShowReports }) => {
// //   const [showProfile, setShowProfile] = useState(false);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [showNewLeadOverlay, setShowNewLeadOverlay] = useState(false);
// //   const getInitials = () => {
// //     if (!userDetails?.firstName || !userDetails?.lastName) return "U";
// //     return `${userDetails.firstName.charAt(0).toUpperCase()}${userDetails.lastName.charAt(0).toUpperCase()}`;
// //   };

// //   const handleSearch = (e) => {
// //     const query = e.target.value;
// //     setSearchQuery(query);
// //     onSearchChange(query);a
// //   };

// //   const getStatusStyle = () => ({
// //     background: connectionStatus === "Active" ? "#28a745" : "#dc3545",
// //     color:"#ffffff",
// //     padding:"5px 8px",
// //     borderRadius: "10px",
// //     marginRight: "10px",
// //     fontWeight: "500",
// //     alignSelf: "center",
// //   });

// //   return (
// //     <div className="timeline-container">
// //       <div className="company-logo">
// //         <img src={img_log} alt="Company Logo" className="timeline-logo" />
// //       </div>
// //       <div className="global-search">
// //         <div className="search-input-container">
// //           <input
// //             type="text"
// //             placeholder="Search..."
// //             value={searchQuery}
// //             onChange={handleSearch}
// //             className="search-input"
// //           />
// //           {searchQuery && (
// //             <FiGlobe
// //               className="global-search-icon"
// //               onClick={() => onGlobalSearch(searchQuery)}
// //               style={{ color: "black", cursor: "pointer" }}
// //             />
// //           )}
// //         </div>
// //       </div>
// //       <div className="profile-section">
// //         <span className="connection-status" style={getStatusStyle()}>
// //           {connectionStatus}
// //         </span>
// //         <div className="profile">
// //           <div
// //             className="profile-avatar profile-initials"
// //             onClick={() => setShowProfile(!showProfile)}
// //           >
// //             {getInitials()}
// //           </div>
// //           {showProfile && (
// //             <ProfileMenu
// //               onClose={() => setShowProfile(false)}
// //               userDetails={userDetails}
// //               accessToken={accessToken}
// //               connectionStatus={connectionStatus}
// //               onCreateNewLead={() => setShowNewLeadOverlay(true)}
// //               onShowReports = {onShowReports}
// //             />
// //           )}
// //           {showNewLeadOverlay && (
// //           <div className="overlay-background">
// //             <div className="overlay-window">
// //               <Newleadadding               
// //               userDetails={userDetails}
// //               accessToken={accessToken} 
// //               onClose={() => setShowNewLeadOverlay(false)} />
// //             </div>
// //           </div>
// //         )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default TimelineComponent;
// // changes after the header

// import React, { useState } from "react";
// import "./Header.css";
// import img_log from "../Images/salesjetlog.png";
// import ProfileMenu from "./Profilemenu";
// import { FiGlobe } from "react-icons/fi";
// import Newleadadding from "./Newleadadding";

// const TimelineComponent = ({ userDetails, accessToken, onSearchChange, onGlobalSearch, connectionStatus, onShowReports, onListView }) => {
//   const [showProfile, setShowProfile] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showNewLeadOverlay, setShowNewLeadOverlay] = useState(false);
//   const [activeView, setActiveView] = useState("list");
//   console.log("User Details in Header:", userDetails);
//   const stored = localStorage.getItem("UIComponents");
//   console.log("Stored UI Components in Header:", stored);

//   const getInitials = () => {
//     if (!userDetails?.firstName || !userDetails?.lastName) return "V";
//     return `${userDetails.firstName.charAt(0).toUpperCase()}${userDetails.lastName.charAt(0).toUpperCase()}`;
//   };

//   const handleSearch = (e) => {
//     const query = e.target.value;
//     setSearchQuery(query);
//     onSearchChange(query);
//   };

//   const getStatusStyle = () => ({
//     background: connectionStatus === "Active" ? "#28a745" : "#dc3545",
//     color:"#ffffff",
//     padding:"5px 8px",
//     borderRadius: "10px",
//     marginRight: "10px",
//     fontWeight: "500",
//     alignSelf: "center",
//   });

//   return (
//     <div className="timeline-container">
//       <div className="company-logo">
//         <img src={img_log} alt="Company Logo" className="timeline-logo" />
//       </div>
//         <div className="view-buttons">
//           <button
//             onClick={() => {
//               setActiveView("list");
//               onListView();
//             }}
//             className={`view-btn list-view-btn ${activeView === "list" ? "active" : ""}`}
//           >
//             List View
//           </button>

//           <button
//             onClick={() => {
//               setActiveView("reports");
//               onShowReports();
//             }}
//             className={`view-btn reports-btn ${activeView === "reports" ? "active" : ""}`}
//           >
//             Reports
//           </button>
//         </div>

//       <div className="global-search">
//         <div className="search-input-container">
//           <input
//             type="text"
//             placeholder="Search..."
//             value={searchQuery}
//             onChange={handleSearch}
//             className="search-input"
//           />
//           {searchQuery && (
//             <FiGlobe
//               className="global-search-icon"
//               onClick={() => onGlobalSearch(searchQuery)}
//               style={{ color: "black", cursor: "pointer" }}
//             />
//           )}
//         </div>
//       </div>
     
//       <div className="profile-section">
//         <span className="connection-status" style={getStatusStyle()}>
//           {connectionStatus}
//         </span>
//         <div className="profile">
//           <div
//             className="profile-avatar profile-initials"
//             onClick={() => setShowProfile(!showProfile)}
//           >
//             {getInitials()}
//           </div>
//           {showProfile && (
//             <ProfileMenu
//               onClose={() => setShowProfile(false)}
//               userDetails={userDetails}
//               accessToken={accessToken}
//               connectionStatus={connectionStatus}
//               onCreateNewLead={() => setShowNewLeadOverlay(true)}
//               onShowReports = {onShowReports}
//             />
//           )}
//           {showNewLeadOverlay && (
//           <div className="overlay-background">
//             <div className="overlay-window">
//               <Newleadadding               
//               userDetails={userDetails}
//               accessToken={accessToken} 
//               onClose={() => setShowNewLeadOverlay(false)} />
//             </div>
//           </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TimelineComponent;
import React, { useState } from "react";
import "./Header.css";
import img_log from "../Images/salesjetlog.png";
import ProfileMenu from "./Profilemenu";
import { FiGlobe } from "react-icons/fi";
import Newleadadding from "./Newleadadding";

const TimelineComponent = ({ userDetails, accessToken, onSearchChange, onGlobalSearch, connectionStatus, onShowReports, onListView }) => {
  const [showProfile, setShowProfile] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showNewLeadOverlay, setShowNewLeadOverlay] = useState(false);
  const [activeView, setActiveView] = useState("list");

  const stored = localStorage.getItem("UIComponents");
  const uiConfig = stored ? JSON.parse(stored) : {};

  const userRole = userDetails?.UserRole || '';
  const userEmail = (userDetails?.mailid || '').toLowerCase();

  const isButtonVisible = (buttonKey) => {
    const buttonConfig = uiConfig?.HeaderButtons?.[buttonKey] || {};
    if (buttonConfig[userEmail]) {
      return buttonConfig[userEmail] === "visible";
    } else if (buttonConfig[userRole]) {
      return buttonConfig[userRole] === "visible";
    }
    return true;
  };

  const getInitials = () => {
    if (!userDetails?.firstName || !userDetails?.lastName) return "V";
    return `${userDetails.firstName.charAt(0).toUpperCase()}${userDetails.lastName.charAt(0).toUpperCase()}`;
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    onSearchChange(query);
  };

  const getStatusStyle = () => ({
    background: connectionStatus === "Active" ? "#28a745" : "#dc3545",
    color:"#ffffff",
    padding:"5px 8px",
    borderRadius: "10px",
    marginRight: "10px",
    fontWeight: "500",
    alignSelf: "center",
  });

  const listViewVisible = isButtonVisible("listviewbutton");
  const reportsVisible = isButtonVisible("reportsbutton");

  return (
    <div className="timeline-container">
      <div className="company-logo">
        <img src={img_log} alt="Company Logo" className="timeline-logo" />
      </div>
      {listViewVisible || reportsVisible ? (
        <div className="view-buttons">
          {listViewVisible && (
            <button
              onClick={() => {
                setActiveView("list");
                onListView();
              }}
              className={`view-btn list-view-btn ${activeView === "list" ? "active" : ""}`}
            >
              List View
            </button>
          )}

          {reportsVisible && (
            <button
              onClick={() => {
                setActiveView("reports");
                onShowReports();
              }}
              className={`view-btn reports-btn ${activeView === "reports" ? "active" : ""}`}
            >
              Reports
            </button>
          )}
        </div>
      ) : null}

      <div className="global-search">
        <div className="search-input-container">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearch}
            className="search-input"
          />
          {searchQuery && (
            <FiGlobe
              className="global-search-icon"
              onClick={() => onGlobalSearch(searchQuery)}
              style={{ color: "black", cursor: "pointer" }}
            />
          )}
        </div>
      </div>
     
      <div className="profile-section">
        {/* <span className="connection-status" style={getStatusStyle()}>
          {connectionStatus}
        </span> */}
        <div className="profile">
          <div
            className="profile-avatar profile-initials"
            onClick={() => setShowProfile(!showProfile)}
          >
            {getInitials()}
          </div>
          {showProfile && (
            <ProfileMenu
              onClose={() => setShowProfile(false)}
              userDetails={userDetails}
              accessToken={accessToken}
              connectionStatus={connectionStatus}
              onCreateNewLead={() => setShowNewLeadOverlay(true)}
              onShowReports = {onShowReports}
            />
          )}
          {showNewLeadOverlay && (
          <div className="overlay-background">
            <div className="overlay-window">
              <Newleadadding               
              userDetails={userDetails}
              accessToken={accessToken} 
              onClose={() => setShowNewLeadOverlay(false)} />
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TimelineComponent;